/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · French (fr) string table · skin-concerns.html
   English is the source of truth in the HTML; this file supplies the
   French counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-fr.js.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.fr = window.TD_I18N.fr || {};
  Object.assign(window.TD_I18N.fr, {

    /* ── Page header ── */
    'concerns.headLabel': 'Trouve ta formule',
    'concerns.headTitle': 'Commence par ce qui<br><em>te dérange.</em>',
    'concerns.headSub': 'Cinq sérums, cinq cibles biologiques. Commence par le besoin qui compte le plus pour toi, et le bon sérum se choisit presque toujours de lui-même.',

    /* ── Jump bar ── */
    'concerns.jumpLabel': 'Aller à',
    'concerns.jumpFirmness': 'Fermeté',
    'concerns.jumpBrightness': 'Éclat',
    'concerns.jumpHydration': 'Hydratation',
    'concerns.jumpFineLines': 'Ridules',
    'concerns.jumpDarkSpots': 'Taches foncées',
    'concerns.jumpTexture': 'Texture',
    'concerns.jumpAcneScars': 'Cicatrices d\'acné',
    'concerns.jumpDullness': 'Manque d\'éclat',

    /* ── Reusable row labels ── */
    'concerns.startWith': 'Commence avec',
    'concerns.shopRoutine': 'Acheter cette routine →',
    'concerns.nameC': 'Serum C — <em>Éclat</em>',
    'concerns.nameA': 'Serum A — <em>Renouvellement</em>',
    'concerns.nameO': 'Serum O — <em>Cellulaire</em>',
    'concerns.nameM': 'Serum M — <em>Hydratation</em>',
    'concerns.nameR': 'Serum R — <em>Clarté</em>',
    'concerns.rolePrimaryDay': 'Principal · Jour',
    'concerns.rolePrimaryNight': 'Principal · Nuit',
    'concerns.rolePrimaryDayNight': 'Principal · Jour + Nuit',
    'concerns.roleLayerDay': 'Couche · Jour',
    'concerns.roleLayerNight': 'Couche · Nuit',

    /* ── Concern 01 · Firmness ── */
    'concerns.c1Num': 'Besoin 01',
    'concerns.c1Title': 'Fermeté<br><em>& élasticité.</em>',
    'concerns.c1Lede': 'La ligne de la mâchoire s\'adoucit. Les pommettes perdent leur soutien. La peau commence à tomber au lieu de se tenir. C\'est le premier signe visible que la production de collagène et d\'élastine a ralenti, et le plus simple à inverser au niveau cellulaire.',

    /* ── Concern 02 · Brightness ── */
    'concerns.c2Num': 'Besoin 02',
    'concerns.c2Title': 'Éclat<br><em>& dommages solaires.</em>',
    'concerns.c2Lede': 'La peau paraît terne même quand tu ne l\'es pas. Souvent c\'est cumulatif : UV, pollution, stress, énergie cellulaire réduite. La vitamine C est l\'ingrédient topique le plus étudié pour l\'éclat. Serum O va plus loin et alimente directement les mitochondries, les cellules qui produisent l\'énergie.',

    /* ── Concern 03 · Hydration ── */
    'concerns.c3Num': 'Besoin 03',
    'concerns.c3Title': 'Déshydratation<br><em>& perte de barrière.</em>',
    'concerns.c3Lede': 'La peau sèche, ce n\'est pas une question de plus de crème hydratante. C\'est une question de barrière lipidique rompue. La plupart des crèmes hydratantes contiennent 65-85% d\'eau plus de l\'alcool et des conservateurs, ce qui dessèche paradoxalement encore plus la peau. Serum M reconstruit la barrière de l\'intérieur avec des lipides identiques à ceux de la peau.',

    /* ── Concern 04 · Fine lines ── */
    'concerns.c4Num': 'Besoin 04',
    'concerns.c4Title': 'Ridules<br><em>& rides.</em>',
    'concerns.c4Lede': 'Lignes superficielles d\'expression, plis plus profonds dus au temps et au soleil. Le renouvellement cellulaire ralentit avec l\'âge ; les vieux kératinocytes restent plus longtemps ; la texture en pâtit. Le rétinol relance le renouvellement et lisse la surface ; la vitamine C reconstruit la structure en dessous.',

    /* ── Concern 05 · Dark spots ── */
    'concerns.c5Num': 'Besoin 05',
    'concerns.c5Title': 'Taches foncées<br><em>& pigmentation.</em>',
    'concerns.c5Lede': 'Les dommages solaires, les changements hormonaux et les marques post-inflammatoires concentrent le pigment en taches inégales. La vitamine C inhibe l\'enzyme (tyrosinase) qui pilote la production de pigment ; le resvératrol neutralise les radicaux libres qui la déclenchent.',

    /* ── Concern 06 · Texture ── */
    'concerns.c6Num': 'Besoin 06',
    'concerns.c6Title': 'Texture<br><em>irrégulière.</em>',
    'concerns.c6Lede': 'Zones rugueuses, pores visibles, une surface inégale sur laquelle le maquillage se pose plutôt qu\'il ne lisse. C\'est presque toujours un problème de renouvellement cellulaire : de vieilles cellules cutanées épaissies qui restent plus longtemps qu\'elles ne le devraient. Le rétinol accélère le cycle.',

    /* ── Concern 07 · Post-acne ── */
    'concerns.c7Num': 'Besoin 07',
    'concerns.c7Title': 'Post-acné<br><em>& cicatrices.</em>',
    'concerns.c7Lede': 'Longtemps après la fin de la poussée, la marque est souvent encore là. Le resvératrol réduit la pigmentation post-inflammatoire et soutient la peau pendant qu\'elle achève la réparation qu\'elle a commencée. À combiner avec Serum A le soir pour un renouvellement cellulaire qui accélère l\'estompage de la marque.',

    /* ── Concern 08 · Dullness / mature ── */
    'concerns.c8Num': 'Besoin 08',
    'concerns.c8Title': 'Teint terne <em>&amp; perte d\'élasticité.</em>',
    'concerns.c8Lede': 'À mesure que la peau mûrit, les systèmes qui la gardent lumineuse et ferme ralentissent. La clarté de la surface s\'estompe et l\'élasticité se relâche. Serum O renouvelle et revitalise la peau mature au niveau cellulaire, soutenant l\'éclat et la fermeté qui diminuent avec l\'âge.',

    /* ── Not sure CTA ── */
    'concerns.unsureLabel': 'Tu hésites encore ?',
    'concerns.unsureTitle': 'Ne choisis pas. Essaie les cinq.',
    'concerns.unsureBody': 'Le Discovery Kit contient des formats de poche de chaque sérum et un guide imprimé. C\'est le moyen le plus rapide d\'apprendre lequel de tes besoins répond à quelle formule : sur ta peau, pas en théorie.',
    'concerns.unsureBtn': 'Obtenir le Discovery Kit',

    /* ── Footer (page-specific extra) ── */
    'concerns.ftLearnRonlan': 'À propos du Dr Ronlán',

    /* ── Theme-only: Concern 08 alt framing (fatigue / low energy) ── */
    'concerns.c8TitleFatigue': 'Vitalité réduite<br><em>& énergie basse.</em>',
    'concerns.c8LedeFatigue': 'Une peau qui manque d\'éclat ne dépend pas toujours de ce qui se voit en surface. Elle dépend de ce qui la produit. La production mitochondriale diminue avec l\'âge, et avec elle, la capacité de la cellule à former du collagène et à réparer les dommages. Serum O alimente le système directement et redonne de l\'énergie aux cellules.',

    /* ── Theme-only: application banner (conditional) ── */
    'concerns.appDividerLabel': 'En pratique',
    'concerns.appDividerQuote': 'Deux gouttes, matin et soir. La peau que tu as, prise en charge.',

    /* ── Theme-only: shortened unsure body (no printed guide) ── */
    'concerns.unsureBodyShort': 'Le Discovery Kit contient des formats de poche de chaque sérum. C\'est le moyen le plus rapide d\'apprendre lequel de tes besoins répond à quelle formule : sur ta peau, pas en théorie.'

  });
})();
